// Production
//  export const IP = "13.212.90.168";
export const IP = "iciec.koncepts.co";
export const localurl = `https://${IP}/api`;



// STAGGING
// export const IP = "13.229.184.79";
// export const localurl = `http://${IP}/api`;

// local
// export const IP = "127.0.0.1:8000";
// export const localurl = `http://${IP}/api`;

